<template lang="pug">
div(:class="classes")
  .text-uppercase.font-weight-bold.primary--text(
    :class="dark && 'custom-title-content--dark'"
  ) {{ text }}
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      default: "page",
    },
    dark: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    sm() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    classes() {
      let r;

      switch (this.type) {
        case "section":
          r = "text-h6";
          break;
        case "page":
          r = !this.sm ? "text-h4" : "text-h5";
          break;
      }

      return r;
    },
  },
};
</script>

<style>
.custom-title-content--dark {
  color: white !important;
}
</style>
